export default "__VITE_ASSET__DsH4Ijfk__"